import { render, staticRenderFns } from "./TraceabilityDataTable.vue?vue&type=template&id=c970c522&scoped=true"
import script from "./TraceabilityDataTable.vue?vue&type=script&lang=js"
export * from "./TraceabilityDataTable.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityDataTable.vue?vue&type=style&index=0&id=c970c522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c970c522",
  null
  
)

export default component.exports